import SvgIcon from "@/components/SvgIcon/index.vue"; // svg component
// @ts-ignore
const req = require.context("./svg", false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);
export function svgIcon(app) {
    app.component("SvgIcon", SvgIcon);
}
